import { createGlobalStyle, keyframes } from 'styled-components';
import { defaultTheme } from '../config';
import themeDefault from './ThemeComponents';


const rotate = keyframes`
from {
  transform: rotate(0deg) ;
}
to{
  transform: rotate(360deg) ;
}
`

export default createGlobalStyle`

@font-face {
    font-family: Montserrat;
    src: url("/assets/fonts/Montserrat-Regular.ttf") format("truetype");
}


@font-face {
    font-family: MontserratBold;
    src: url("/assets/fonts/Montserrat-Bold.ttf") format("truetype");
}



*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: 0
}

html{
  width: 100%;
  min-height: 100vh !important;


}

.whiteModal { 
  p,span,h3, strong, h2, h1, h4, nav, aside {
    color: #333 !important;
  }
}


.whiteModalMedium { 
 background : #fff !important;
    width: 90% !important;
    max-width: 800px;
    
    border-radius: 15px;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 

    >h2{
      color: #333;
    }
 

    >div {
      width: 100%;
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
          border: 0px !important;
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
 
  }


  p,span,h3, strong, h2, h1, h4, nav, aside {
    color: #333 !important;
  }
}
body {
  background: url('/assets/Fundo.jpeg') no-repeat center;
background-size: cover ;
background-attachment: fixed;
 

>iframe {
  position: relative !important;
}

.greenDiv{
  background: #1c9284 !important;

  strong{
    color: #fff !important;
  }
}

.bg1{
  @media (max-width: 750px) {
    padding: 50px 20px;
  }
}

.bg3{
 
 
   background: #082740;
   min-height: 100vh;
   padding: 100px 0px;

   div{
     div.p50 {
      p.description,h2,strong{
        width: 100%;
        color: #fff !important;
        text-align: center !important;
        max-width: 612px;
      }

      p.description{
        max-width: 612px;
      }

      h2{
        margin: 20px 0px;
      }

      .split {
        width: 100%;
        max-width: 1000px;
        display: flex ;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0px;
        margin-bottom: 60px;

        @media (max-width: 750px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
      
        >.highlights{
          width: 100%;
          max-width: 550px;
          

          >h2{
            font-size: 28px !important;
            color: rgb(38, 168, 133) !important;
            text-align:center  !important;
            width: 100%;
            margin-bottom: 5px !important;
          }

          >p{
            font-size: 24px !important;
            color: rgb(255, 255, 255) !important;
            text-align:center !important;
            width: 100%;
          }
        }
      }
    }
  }
 }

 .bg4{
 
 
  background: url('/apoio/bg4.png') left top;
 background-attachment: fixed;
   background-size: cover;
 min-height: 100vh;
 padding: 100px 0px;

 div{
   div.p50 {
    p.description,h2,strong{
      width: 100%;
      color: #fff !important;
      text-align: center !important;
      max-width: 612px;
    }

    p.description{
      max-width: 612px;
    }

    h2{
      margin: 0px 0px !important;
    }

    .split {
      width: 100%;
      max-width: 1000px;
      display: flex ;
      justify-content: space-between;
      align-items: center;
      margin: 20px 0px;
      margin-bottom: 60px;

      @media (max-width: 750px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
    
      >.highlights{
        width: 100%;
        max-width: 550px;
        

        >h2{
          font-size: 28px !important;
          color: rgb(38, 168, 133) !important;
          text-align:center  !important;
          width: 100%;
          margin-bottom: 5px !important;
        }

        >p{
          font-size: 24px !important;
          color: rgb(255, 255, 255) !important;
          text-align:center !important;
          width: 100%;
        }
      }
    }
  }
}
}

.bg2{
   background: url('/apoio/bg2.jpeg') left top;
 background-attachment: fixed;
   background-size: cover;
   min-height: 100vh;
   padding: 100px 0px;

   div{
     div.p50 {
      p.description,h2,strong{
        width: 100%;
        color: rgb(3, 88, 124) !important;
        text-align: left !important;
        max-width: 612px;
      }

      p.description{
        max-width: 612px;
        @media (max-width: 1250px) {
font-size: 16px !important;
  }

  @media (max-width: 750px) {
    font-size: 16px !important;
  }
        
      }
    }
  }
 }
 
.searchButton{
    background: rgba(0,100,0);
    color: #fff;
    width: 50px;
    height: 50px;
    padding: 10px;
    margin: 5px;
    border: 0px;

    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
    transition: 0.5s all;
    border-radius: 50%;

    >svg{
      width: 30px;
      font-size: 30px;
      color: #fff;
    }

    &:hover{
      background: rgba(0,150,0);
    }
  }

  .searchButtonMini{
    background: rgba(0,100,0);
    color: #fff;
    width: 30px;
    height: 30px;
    padding: 5px;
    margin: 5px;
    border: 0px;

    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
    transition: 0.5s all;
    border-radius: 50%;

    >svg{
      width: 20px;
      font-size: 20px;
      color: #fff;
    }

    &:hover{
      background: rgba(0,150,0);
    }
  }
 


  background-position:  top;
  
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;



  color: #fff;
  -webkit-font-smoothing: antialiased;
  padding: 0;
  margin: 0 !important;
  min-height: 100vh !important;
  min-height: 100% !important;
  position: relative;



}

.tooltip{
  background: #777 ;
  color: #333;
}

.spin {
  animation: ${rotate} 2s infinite ;
}

.table{
  width: 100%;
  border-collapse: collapse;
  td{
    border: 1px solid #ddd;
    padding: 10px;
    color: #333;

  }
}


.searchDivStart2{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items:center;
        max-width: 1600px;
        padding: 0px 15px;
        margin: 0px auto;

        >select, input {
          min-width: 300px;
          padding: 10px;
          border-radius: 15px;
          background: #fff ;
          border: 0px;
          margin:  10px;
        }

        button{
          padding: 10px;
          border-radius: 15px;
          background: #fff ;
          border: 0px;

          >svg{
            font-size: 18px;
          }
        }

        @media (max-width: 750px) {
    justify-content: center;
    flex-direction: column;
    select, input {
      width: 100%;

    }

    div{
      width: 100%;
    }
    
  }
      }

.slick-slider{
  width: 100%;

 
}

.slick-prev{
  background: ${themeDefault.globalBackground} !important ;
  width: auto !important ;
  height: auto !important ;
  border-radius: 50%;
  z-index: 1;
  &:before{
    color: ${themeDefault.globalColor};
    font-size: 40px;
    z-index:10;
    opacity: 1 ;
  }
}

.slick-next{
  background:  ${themeDefault.globalBackground} !important ;
  width: auto !important ;
  height: auto !important ;
  border-radius: 50%;
  z-index: 1;
  &:before{
    color:  ${themeDefault.globalColor};
    font-size: 40px;
    opacity: 1 ;
  }
}

.fixedWhatsapp{
  position: fixed;
    bottom: 15px;
    right: 0px;
    border-radius: 10px 0px 0px 10px;
    background: rgb(50,150,26);
    color: #fff !important;
    padding: 15px;
    border: 0px;
}

.CaptureLeads{
  min-width: 250px;
  background: ${themeDefault.globalBackground}  ;
  color: ${themeDefault.textComponent.title.color} ;
  padding: 10px 15px;
  border-radius: 5px;
  border: 0px;
}

.divSecoundaryBackground {
  background: ${themeDefault?.textComponent?.title.color} !important;
}

.shadow{
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.padding{
  padding: 15px;
}

.margin{
  margin: 15px;
}

.shadowBox{
  display: flex;
    background: rgb(255, 255, 255) !important;
    box-shadow: rgb(7 13 28 / 25%) 0px 10px 100px;
    margin: 20px 0px;
    border-radius: 10px;
    padding: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

#root{
  min-height: 100vh;
 


}

body, input, button{
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}

h1,h2,h3,h4,h5,h6, strong{
font-weight: 600;
font-family:  "Open Sans", sans-serif;
color : ${themeDefault.textComponent.title.color};
}

h2{

      font-size: 16px;
}

p, span{
  font-family:"Open Sans", sans-serif;
  color : ${themeDefault.textComponent.paragraph.color};
}

.react-select__single-value, .react-select__placeholder{
  font-size: 16px !important;
}

.everBlack{
  color: #333;
  p,strong,h2,h1,h3,label{
    color: #333 !important;
  }
}

.activeButton{
    background: #1c9284 !important; padding: 10px; border-radius: 10px; color: #fff; font-size: 12px;
    transition: 0.5s all;

  
    &:hover{
     
        font-size: 14px;
     
    }
  }

.buttonBigBlue{
  max-width: 388px;
  display: flex ;
  align-items: center;
  justify-content: center;
    width: 100%;
    margin: 20px auto;
    margin-bottom: 0px;
  >button{
  align-self: center;
    background-color: #908857;
    border-bottom-style: none;
    border-color: #000000;
    border-left-style: none;
    border-radius: 20px;
    border-right-style: none;
    border-top-style: none;
    border-width: 0px;
    color: #FFFFFF;
    cursor: pointer;
    font-family: "Open Sans", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: bold;
    height: 50px;
    justify-content: center;
    line-height: 1.42857;
    margin-bottom: 20px;
    margin-top: 0px;
    max-width: 388px;
    text-align: center;
    text-decoration: none;
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    margin-bottom: 10px;

  }
}

.buttonBigGreen{

  align-self: center;
    background-color: #1c9284;
    border-bottom-style: none;
    border-color: #1c9284;
    border-left-style: none;
    border-radius: 20px;
    border-right-style: none;
    border-top-style: none;
    border-width: 0px;
    color: #FFFFFF;
    cursor: pointer;
    font-family: "Open Sans", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: bold;
    height: 50px;
    justify-content: center;
    line-height: 1.42857;
    margin-bottom: 20px;
    margin-top: 0px;
    max-width: 388px;
    text-align: center;
    text-decoration: none;
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    margin-top: 20px;
 
}

button{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  >svg {
    margin: 0 5px;
  }
}

.wave {

  width: 200%;
  margin-left: -20%;
  z-index:0;

  @media (max-width: 1250px) {
    width: 400%;
    margin-left: -50%;
  }

  @media (max-width: 750px) {
    width: 800%;
    margin-left: -50%;
  }



}


.computerOnly{
display: flex !important;
@media (max-width: 1200px) {
    display: none !important;
  }
}

.mobileOnly{
display: none !important;
@media (max-width: 1200px) {
    display: flex !important;
  }
}

.fixedBottom{
    z-index: 0;
    position: fixed;
    bottom: -30px;
    right: 0px;
    width: 45%;
}

div.defaultButton {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      max-width: 250px;
      padding: 20px;
      text-align: center;
      background: #fff !important;
      border: 2px solid rgb(0, 15, 64);
      color: rgb(0, 15, 64)  !important;
font-weight: bold;
      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;

      border-radius: 10px;
      box-shadow: 0px 5px 15px rgba(255,255,255,0.3);

      svg{
        cursor: pointer;
        transition: 0.4s all ;
        &:hover{
          transform: scale(1.1) ;
        }
      }
   
    }

button.defaultButton {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      max-width: 250px;
      padding: 20px;
      text-align: center;
      background: #fff !important;
      border: 0px solid rgb(0, 15, 64);
      color: rgb(0, 15, 64)  !important;
font-weight: bold;
      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;

      border-radius: 10px;
      box-shadow: 0px 5px 15px rgba(255,255,255,0.3);
      &:hover {
        transform: translateY(-5px);
 
  
      }
    }


button.defaultButtonRed {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background: red !important;
      color: #fff  !important;

      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }

    .defaultButtonReverse {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      flex-direction: column;
      display: flex ;
      justify-content: center;
      align-items: center;
 
      color: #fff  !important;
      font-weight: bold;

      background: #134842 !important;

      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;
    
      &:hover {
        transform: translateY(-10px);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }

    .tip{
      padding: 5px;
     font-size: 14px;
      width:100%;
      text-align: left;
      font-weight: bold;
   
      color: #916f00 !important;
      display: flex ;
      justify-content: flex-start;
      align-items: center;

      >svg {
        animation: ${rotate} 5s infinite ;
      }
     
  
    }

    .rotateAnimation{
      animation: ${rotate} 5s infinite ;
    }

    .simpleButton {
         margin-top: 0px;
 
  
      padding: 5px;
      text-align: center;
      background: #fff !important;
      color: #333  !important;
      font-weight: bold;

      display: flex;
      justify-content: center;
      text-align: center;

      >a{
        color: #333  !important;
        font-weight: bold;

      }

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;

      &:hover {
        transform: scale(1.1);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }


    .defaultButtonReverseMini {
         margin-top: 0px;
      width: 100%;
      max-width: 200px;
      padding: 5px 10px;
      text-align: center;
      background: #f16621 !important;
      color: #fff  !important;
      font-weight: bold;

      display: flex;
      justify-content: center;
      text-align: center;

      >a{
        color: #fff  !important;
        font-weight: bold;

      }

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }

    button.defaultButtonMini,     button.defaultButtonMini2, button.buttonBlue {
         margin-top: 0px !important;
         padding: 5px !important;
      width:auto !important;
      min-width:auto !important;

      text-align: center !important;
      justify-content: center !important;
      background: rgb(0,15,64) !important;
      color: #fff  !important;

      display: flex  !important;
      justify-content: center !important;


      transition: background 0.5s;
      border: 0;
      border-radius: 10px;

      &:hover {
        background: ${defaultTheme.defaultBackground}  !important;
      }
    }


    button.defaultButtonMini2{
      padding: 10px 20px  !important ;
      margin-top: 25px ;
    }

    button.buttonBlue{
      background: rgb(0,100,150) !important;

      &:hover {
        background: rgb(0,120,180) !important;
      }
    }


    .closeButton{
      padding: 10px;
      border: 0;
      opacity: 0.8;
      cursor: pointer;
      background: #f15a23 !important;
      color: #fff  !important;
      border-radius: 10px  !important;
      transition: 0.5s all;

      margin: 5px;
      &:hover{
        opacity: 1;
      }
    }


    a {
      text-decoration: none !important;
    }


    .lineIcon {
      margin:5px;
      background: #fff;
       border: 1px solid #333;
       border-radius: 50%;
       height: 35px;
       width: 35px;
       padding: 5px;
       
       >svg{
         width: 25px !important;
         font-size: 25px;

       }
       display: flex;
       align-items: center;
       justify-content: center;
    }

    .videoContainer{
      width: 100%;
      position: relative;
      height: auto;
   
    }

form {
    >div{
  
  background: #fff !important;
  color: #333  !important;
  border: 1px solid #ddd  !important;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.2)  !important;

  span{
    color: #333  !important;
  }

  input {
    color: #333  !important;

    &::placeholder {
    color: #333  !important;
  }
  }
}
}
`;
